var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRun(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.511 12.004L6.233.463C4.082-.765 1.889.578 1.889 2.993v24.093c0 2.046 1.332 2.979 2.57 2.979.583 0 1.177-.184 1.767-.543l20.369-12.468c1.024-.629 1.599-1.56 1.581-2.555-.017-.996-.623-1.906-1.665-2.495zm-1.281 2.823L4.862 27.292a1.297 1.297 0 01-.319.147 1.354 1.354 0 01-.04-.353V2.994c0-.248.045-.373.045-.404.08.005.22.046.396.146l20.275 11.541c.25.143.324.267.348.24-.013.034-.098.161-.337.31z",
    fill: "#fff",
    "data-original": "#010002",
    xmlns: "http://www.w3.org/2000/svg"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRun);
export default __webpack_public_path__ + "static/media/run.1800aa4a.svg";
export { ForwardRef as ReactComponent };